//import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import StickyButtonTriggerComponent from './js/sticky-button-trigger.component';

ComponentsFactory.getInstance().define('sticky-button', StickyButtonTriggerComponent);
